var _style, _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisageM2G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CCCCCC;stroke:#777777;stroke-width:9;stroke-miterlimit:10;}\r\n\t.st1{fill:#777777;}\r\n\t.st2{fill:none;stroke:#777777;stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72.7,
    cy: 72.5,
    r: 67.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 53.3,
    cy: 56.4,
    r: 8.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 91.7,
    cy: 56.4,
    r: 8.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.7,98.7c0,0,6.9-8.4,19.8-8.4s18,8.4,18,8.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisageM2G);
export default __webpack_public_path__ + "static/media/visage_m2g.2263f5d2c279bdb1ecc5f01f387a6a04.svg";
export { ForwardRef as ReactComponent };